module.exports = __webpack_public_path__ + "images/notification-full5471d941f9fe6a1a90102423b280b431.svg";